<template>
    <el-card class="box-card mg-b5" v-if="orderInfo">
        <el-descriptions :column="4" :border="true" :colon="false" size="mini">
            <el-descriptions-item labelClassName="my-descriptions-label" :span="2" label="询价单标题">
                {{orderInfo.title}}
            </el-descriptions-item>
            <el-descriptions-item labelClassName="my-descriptions-label" label="询价单号">
                {{orderInfo.xjOrder}}
            </el-descriptions-item>
            <el-descriptions-item labelClassName="my-descriptions-label" label="询价方式">
                {{xjText}}
            </el-descriptions-item>
            <el-descriptions-item labelClassName="my-descriptions-label" label="采购组织">
                {{orderInfo.buyerUnitName}}
            </el-descriptions-item>
            <el-descriptions-item labelClassName="my-descriptions-label" label="本轮报价截止时间">
                {{orderInfo.bjEndTime}}
            </el-descriptions-item>
            <el-descriptions-item labelClassName="my-descriptions-label" label="货币种类">
                {{currencyInfo.obj[orderInfo.currency]}}
            </el-descriptions-item>
            <el-descriptions-item labelClassName="my-descriptions-label" label="项目类型">
                {{getTypeName(orderInfo.projectType)}}
            </el-descriptions-item>
            <el-descriptions-item labelClassName="my-descriptions-label" label="采购员">
                {{orderInfo.userName}}
            </el-descriptions-item>
            <el-descriptions-item labelClassName="my-descriptions-label" label="采购部门">
                {{orderInfo.unitName}}
            </el-descriptions-item>
            <el-descriptions-item labelClassName="my-descriptions-label" label="轮次">
                {{orderInfo.rounds}}
            </el-descriptions-item>
            <el-descriptions-item labelClassName="my-descriptions-label" label="发布日期">
                {{orderInfo.publishDateTime}}
            </el-descriptions-item>
            <el-descriptions-item labelClassName="my-descriptions-label" label="订单状态">
                {{formatStatus()}}
            </el-descriptions-item>
            <el-descriptions-item labelClassName="my-descriptions-label" label="附件">
                <el-tag v-if="!orderInfo.fileSrc" type="info">无附件 </el-tag>
                <el-link v-else :underline="false" :href="baseURL+orderInfo.fileSrc" target="_blank">
                    <el-tag type="success">查看附件</el-tag>
                </el-link>
            </el-descriptions-item>
            <el-descriptions-item labelClassName="my-descriptions-label" label="备注" :span="2">
                {{orderInfo.remark}}
            </el-descriptions-item>
            <el-descriptions-item v-if="checkRole('cgy_role')" labelClassName="my-descriptions-label" label="询价备注" :span="4">
                {{orderInfo.buyerRemark}}
            </el-descriptions-item>
            <el-descriptions-item v-if="!checkRole('gys_role') && orderInfo.dingbiaoRemark" labelClassName="my-descriptions-label" label="开标说明" :span="4">
                {{orderInfo.dingbiaoRemark}}
            </el-descriptions-item>
        </el-descriptions>
    </el-card>
</template>
<script>
import { xjtypes,projectTypeOption } from'@/utils/dict'
export default {
    props:['orderInfo'],
    computed: {
        currencyInfo:function(){
            return this.$store.getters['app/currencyInfo'];
        },
        xjText:function(){
            let str = '';
            if(this.orderInfo && this.orderInfo.xjFs){
                this.xjtypes.forEach((item)=>{
                    if(item.code == this.orderInfo.xjFs){
                        str = item.name;
                    }
                });
            }
            return str;
        },
    },
    mounted(){
        console.log(this.orderInfo)
    },
    methods:{
        getTypeName(code){
            let name =''
            projectTypeOption.forEach((item) => {
                if(item.code == code){
                    name = item.name
                }
            })
            return name
        },
        // 状态值转换
        formatStatus: function() {
            let stateObj = {};
            if(this.checkRole('cgy_role')){
                // 1:待询价,2:询价中,3:已结束询价待审批,4:询价审批中,5:定标审批被驳回,6:定标审批通过,7:已发布中标通知,
                stateObj = {
                    's_1':'待询价',
                    's_2':'询价中',
                    's_3':'待定标',
                    's_4':'定标审批中',
                    's_5':'定标审批被驳回',
                    's_6':'定标审批通过',
                    's_7':'已发布中标通知',
                }
                return stateObj[`s_${this.orderInfo.orderState}`];
            }else if(this.checkRole('gys_role')){
                // 1:待参与,2:已放弃,3:报价中,4:报价已提交,5:已中标,6:未中标,
                stateObj = {
                    's_1':'待参与',
                    's_2':'已放弃',
                    's_3':'报价中',
                    's_4':'报价已提交',
                    's_5':'已中标',
                    's_6':'未中标',
                }
                return stateObj[`s_${this.orderInfo.gysOrderState}`];
            }
        },
    },
    data(){
        return {
            xjtypes
        }
    },
}
</script>
<style>
.el-descriptions .is-bordered .el-descriptions-item__cell{
    border:1px solid #82848a;
}
</style>
